import { combineReducers } from 'redux';
import user from '../common/state/user/User.reducer';
import version from '../common/state/version/Version.reducer';
import snackbar from '../common/state/snackbar/Snackbar.reducer';
import reports from '../common/state/reports/Reports.reducer';
import help from '../common/state/help/Help.reducer';
import push from '../common/state/push/Push.reducer';
import notifications from '../common/state/notifications/Notifications.reducer';
import globalDateTime from '../common/state/datetime/DateTime.reducer';

export default combineReducers({
  user,
  version,
  snackbar,
  reports,
  help,
  push,
  notifications,
  globalDateTime,
});
